import {IDS} from '../improvement-action-id.constants';
import {TYPES} from "../improvement-action-type.constants";
import * as Actions from '../improvement.actions';
import * as AccAction from '../../accreditation.actions';
import {GRID_FETCH, GRID_FILTER, GRID_RELOAD} from "../../../../common/grid/grid.constants";
import get from 'lodash/get';
import moment from "moment";
import {formatDate} from "../../../../common/utils/util.date";
import {DATE_FORMAT} from "../../../../common/utils/util.constants";
import watch from "redux-watch";
import pick from "lodash/pick";
import {TAB_ENABLE, TAB_SELECT} from "../../../../common/tabs/tabs.constants";
import find from "lodash/find";

class ImprovementActionController {
    constructor($ngRedux,
                $state,
                $stateParams,
                $uiRouterGlobals,
                $filter,
                $timeout,
                $transitions,
                $mdDialog,
                Notifier,
                DocumentManager,
                EmployeeService,
                AuthService,
                FileActions,
                $scope) {
        this.$ngRedux = $ngRedux;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$uiRouterGlobals = $uiRouterGlobals;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.$transitions = $transitions;
        this.$mdDialog = $mdDialog;
        this.Notifier = Notifier;
        this.DocumentManager = DocumentManager;
        this.EmployeeService = EmployeeService;
        this.AuthService = AuthService;
        this.FileActions = FileActions;
        this.identifier = IDS.rcoImprovement;
        this.$scope = $scope;
    }

    $onInit() {
        this.schemeCode = this.$stateParams.itemCode;
        const user = this.AuthService.getUser();
        this.userUuid = user.uuid;
        this.isAdmin = user.type === 'Administrator';

        this.unsubscribe = this.$ngRedux.connect(state => {
            const accDashboardLocationYear = state.accreditation.accDashboardLocationYear;
            const subModule = state.accreditation.rcoImprovement;
            // this.maxDueDate = moment(`${maxYear}-01-01`).add(fiscalYearStart, 'months').subtract(1,'days').toDate();
            this.minDueDate = new Date();

            return {
                improvementAction: subModule.improvementAction,
                fiscalYear: accDashboardLocationYear.year,
            }
        }, {
            ...AccAction,
            ...Actions,
            ...this.FileActions,
        })(this);
    }

    async onAutocompleteKeywordQuery (keyword, path = undefined) {
        return await this.fetchEmployeesAndManagers(
            keyword,
            this.improvementAction.location_uuid,
            `${this.identifier}.${IDS.assigneeCandidates}`,
        );
    }

    onSubmit() {
        const form = this.$scope.actionForm
        if (form.$invalid) {
            this.Notifier.error('COMMON.FIELDS_REQUIRED');
            for (const item of form.$$controls) {
                if (item.$invalid) {
                    item.$setTouched();
                }
            }
            return;
        }
        this.updateImprovementAction({
            task_id:            this.improvementAction?.uta_id,
            assignee_uuid:      this.improvementAction?.assignee.subject_uuid,
            title:              this.improvementAction?.title,
            description:        this.improvementAction?.description,
            due_date:           formatDate(this.improvementAction?.dueDate, DATE_FORMAT.OUTPUT),
        }).then(() => {
            this.$ngRedux.dispatch({
                type: GRID_RELOAD,
                id: this.identifier,
                path: IDS.improvementStepsGrid,
            });

            this.$ngRedux.dispatch({
                type: GRID_RELOAD,
                id: this.identifier,
                path: IDS.improvementActionsGrid,
            });
            // this.$ngRedux.dispatch({
            //     type: TAB_SELECT,
            //     id: IDS.app_accreditation_scheme_improvement,
            //     state: IDS.app_accreditation_scheme_improvement_list,
            // });
            // form.$setPristine();
            // form.$setUntouched();
        });
    }

    onCancel() {
        this.$ngRedux.dispatch({
            type: TAB_SELECT,
            id: IDS.app_accreditation_scheme_improvement,
            state: IDS.app_accreditation_scheme_improvement_list,
        });
    }

    $onDestroy() {
        if(this.unsubscribe)
            this.unsubscribe();
    }
}

ImprovementActionController.$inject = [
    '$ngRedux',
    '$state',
    '$stateParams',
    '$uiRouterGlobals',
    '$filter',
    '$timeout',
    '$transitions',
    '$mdDialog',
    'Notifier',
    'DocumentManager',
    'EmployeeService',
    'AuthService',
    'FileActions',
    '$scope']

export const improvementAction = {
    controller: ImprovementActionController,
    template: require('./action.html')
}
